import { useEffect, useState } from 'react';

type Props = {
    isReady?: boolean
    isFocused?: boolean
    init?: boolean
};

export const useIsFocusedHeading = ({
    isReady = true,
    isFocused = false,
    init,
}: Props): boolean => {
    const [initFocus, setInitFocus] = useState<null|true>(null);
    // When init is true it will ignore isFocused value on initial load
    const [preservedInitFocus, setPreserveInitFocus] = useState<null|true>(init ? true : null);

    useEffect(() => {
        // Preserve isFocused true
        if(preservedInitFocus === null && isFocused) {
            setPreserveInitFocus(isFocused);
        }
    }, [preservedInitFocus, isFocused]);

    useEffect(() => {
        // Wait for both flags to be true
        if(isReady && preservedInitFocus) {
            setInitFocus(true);
        }
    }, [isReady, preservedInitFocus]);

    useEffect(() => {
        // Reset initial focus so we can use pass-in isFocused
        if(initFocus) {
            setInitFocus(null);
        }
    }, [initFocus]);

    return initFocus ?? isFocused;
};
